import {TOCSLIDER} from './TocSliderTypes'

export const changeOpacity = opacity => {
    return {
        type: TOCSLIDER,
        load: opacity
    }
}

